<template>
  <!-- prettier-ignore -->
  <div class="contract">

    <div class="contract-date">
      <ovp-checkbox
        v-model="form.immigrant"
        class="contract-date__immigrant"
        name="immigrant"
        :title="$t('screen.welcome.immigrant.title')"
        :validate="v.immigrant"
      />

      <transition
        mode="out-in"
        :name="transition"
        @enter="enter"
        @after-enter="afterEnter"
        @leave="leave">
        <div
          v-if="form.immigrant"
          class="contract-date--inline">
          <ovp-date-input
            ref="contractStartDate"
            v-model="form.dateOfEntry"
            is-native
            autofocus
            class="contract-date__date"
            name="contractStartDate"
            required
            :max="dateRanges.max"
            :min="dateRanges.min"
            :theme="theme"
            :title="$t('screen.personalData.preInsurer.currentRegistration')"
            :validate="v.dateOfEntry"
          />
          <ovp-icon
            v-tooltip="{ trigger: 'click', content: $t('screen.welcome.immigrant.tooltip') }"
            class="contract-date__tooltip"
            art="light"
            name="circle-info"
            html-tooltip
          />
        </div>
      </transition>
    </div>

    <div class="contract-location">
      <ovp-zip-chooser
        ref="zipchooser"
        v-model="form.address"
        :autofocus="!form.address.zipCode && !isWww"
        name="location"
        required
        replace
        :contract-start-date="contractStartDate"
        :hint="$t('location.placeholder')"
        :theme="theme"
        :title="$t('person.plz')"
        :validate="v.address"
      />
    </div>
  </div>
</template>

<script>
import HeightTransitionMixin from '@/mixins/HeightTransition'

import { DateTimeHelper } from '@/helpers'

export default {
  name: 'OvpPersonsContract',

  mixins: [HeightTransitionMixin],

  model: {
    prop: 'value',
    event: 'update',
  },

  props: {
    theme: {
      type: String,
      default: 'light',
    },

    v: {
      type: Object,
      required: true,
    },

    value: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      form: this.value,
      transition: 'slide-down',
      contractStartDate: null,
    }
  },

  watch: {
    contractStartDate: {
      immediate: true,
      handler: function (value) {
        this.contractStartDate = value ? value : DateTimeHelper.getDefaultContractStartDate()
      },
    },

    'form.dateOfEntry': function (value) {
      this.contractStartDate = value
      this.v.dateOfEntry.$reset()
    },

    'form.immigrant': function (value) {
      // reset dateOfEntry, only applies if immigrant
      if (!value) {
        this.form.dateOfEntry = null
        this.v.dateOfEntry.$reset()
      }
    },
  },

  computed: {
    dateRanges() {
      return {
        min: DateTimeHelper.getMinContractStartDate(),
        max: DateTimeHelper.getMaxContractStartDate(),
      }
    },

    isWww() {
      return !!this.$root.$options.propsData.isWww
    },
  },
}
</script>

<style name="animations" scoped>
.slide-down-enter-active,
.slide-down-leave-active,
.slide-up-enter-active,
.slide-up-leave-active {
  transition-duration: 0.5s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.slide-down-enter,
.slide-up-leave-active,
.slide-down-leave-active,
.slide-up-enter {
  opacity: 0;
  height: 0;
  transform: translate(0, -2em);
}
</style>

<style name="mobile" scoped>
.contract {
  &-date {
    &--inline {
      display: flex;
      flex-direction: row;
    }

    &__date {
      flex: 1 0 auto;
      margin: 0 0 15px 0;
    }

    &__tooltip {
      cursor: pointer;
      flex: 0 0 auto;
      margin-left: 10px;
      margin-top: 15px;
    }

    label.contract-date__immigrant {
      height: 50px;
      padding: 20px 0 10px 5px;
    }
  }
}
</style>

<style name="desktop" scoped>
@media (--md) {
  .contract {
    &-date {
      &__date {
        flex: 0 0 auto;
        width: 250px;
        margin: 0 0 20px 0;
      }

      label.contract-date__immigrant {
        width: 250px;
        margin: 0 0 20px 0;
      }
    }

    &-location {
      width: 250px;
    }
  }
}
</style>
